module.exports = __webpack_public_path__ + "media/logos/blik_logo-7a04641c.svg";